import { render, staticRenderFns } from "./TeacherFeedbackFilter.vue?vue&type=template&id=33383625&scoped=true&"
import script from "./TeacherFeedbackFilter.vue?vue&type=script&lang=js&"
export * from "./TeacherFeedbackFilter.vue?vue&type=script&lang=js&"
import style0 from "./TeacherFeedbackFilter.vue?vue&type=style&index=0&id=33383625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33383625",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
